import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import MapsHomeWorkSharpIcon from "@mui/icons-material/MapsHomeWorkSharp";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Avatar,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popover,
  Popper,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useMatch, useNavigate } from "react-router-dom";
import ArrowDropdownIcon14pxSvg from "../../../assets/images/icons/ArrowDropdownIcon14pxSvg";
import PlusIcon14pxSvg from "../../../assets/images/icons/PlusIcon14pxSvg";
import default_avatar from "../../../assets/images/logo/default-avatar.jpg";
import company_logo from "../../../assets/images/logo/my-company-logo.png";
import {
  ControlPanelNavbarButton,
  ControlpanelPrimaryButton,
  ControlpanelSuccess3thButton,
  ErrorSecondaryButton,
  HambugerIconButton,
} from "../../../components/StyledButton";
import {
  NavbarLanguageMenuList,
  NavbarMenuItem,
} from "../../../components/StyledComponents";
import { StyledLink } from "../../../components/StyledLink";
import { useAuth } from "../../../context/AuthContext";
import i18n from "../../../n18i";
import { changeLanguage } from "../../../redux/language/reducer";
import ChevronDown10pxSvg from "./../../../assets/images/icons/ChevronDown10pxSvg";
import LoginOptionsDialog from "./LoginOptionsDialog";
import VerifyYourEmailDialog from "./VerifyYourEmailDialog";
import { getAccountList } from "../../../axios/Account/AccountApi";
import NotificationBell from "./NotificationBell";
import IconHelp from "../../../assets/images/icons/IconHelp";
import NotificationDialog from "./NotificationDialog";
import useSocket from "../../../hooks/socket";
import {
  getListNotification,
  updateNotification,
} from "../../../axios/Notification/NotificationApi";
import { toast } from "react-toastify";
import { getUserList } from "../../../axios/User/UserApi";
import NotificationFirstDialog from "./NotificationFirstDialog";
import { getListDepartment } from "../../../axios/Department/DepartmentApi";
import Dashboard16pxSvg from "../../../assets/images/icons/Dashboard16pxSvg";
import ArrowRepeatIcon16pxSvg from "../../../assets/images/icons/ArrowRepeatIcon16pxSvg";
import LanguageIcon from '@mui/icons-material/Language';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UserIcon16pxSvg from "../../../assets/images/icons/UserIcon16pxSvg";
import CompanyIcon16pxSvg from "../../../assets/images/icons/CompanyIcon16pxSvg";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LanguageIcon20pxSvg from "../../../assets/images/icons/LanguageIcon20pxSvg";
import RefreshCircleIcon20pxSvgV2 from "../../../assets/images/icons/RefreshCircleIcon20pxSvgV2";
import { useRefresh } from "../../../context/RefreshContext";
import ChangeRole20pxSvg from "../../../assets/images/icons/ChangeRole20pxSvg";
import { useNotification } from "../../../context/NotificationContext";
import { useTour } from "@reactour/tour";
import { getTourStepsByPage } from "../../../tours";


const SIDEBAR_TITLE = {
  dashboard: "drawer.dashboard",
  "user-management": "drawer.user-management",
  "user-groups-management": "drawer.user-groups",
  "shift-and-roster-management": "drawer.shift-and-roster",
  "leave-and-holiday-management": "drawer.leave-and-holiday",
  "devices-management": "drawer.devices",
  "event-log-management": "drawer.event-log",
  reports: "drawer.reports",
  settings: "drawer.settings",
  subscription: "drawer.subscription",
  "admin-tasks": "drawer.admin-tasks",
  timesheet: "drawer.timesheet",
  "visitor-management": "drawer.visitor-management",
  "company-profile": "drawer.company-profile",
  "my-profile": "drawer.my-profile",
};
let stompClient = null;

const ControlPanelNavbar = ({ allowRoute, isCollapse, setIsCollapse }) => {

  const { handleRefreshData } = useRefresh();
  const { profile, logout, isEmployee, isAdmin, dataConfig, setCookie } = useAuth();
  const language = useSelector((state) => state.languageR.language);
  const { t } = useTranslation();
  const [isSm, setIsSm] = useState(false);
  const [isMd, setIsMd] = useState(false);
  const [isLg, setIsLg] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const navigate = useNavigate();
  const [allUser, setAllUser] = useState([]);
  const [refreshData1, setRefreshData1] = useState(false);
  const { setSteps, setCurrentStep, setIsOpen } = useTour();

  const url = window.location.origin + "/portal";

  const { client } = useSocket(
    url === "http://localhost:3000/portal"
      ? "http://localhost:8080/portal"
      : dataConfig.url_connect_socket
  );

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    navigate("/login");
  };

  const match = useMatch("/controlpanel/:page");
  const pageName = match ? match.params.page : "";
  const pageTitle = allowRoute ? t(SIDEBAR_TITLE[pageName]) : "";
  const [openLanguage, setOpenLanguage] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openLoginOptions, setOpenLoginOptions] = useState(false);
  const [openVerifyEmail, setOpenVerifyEmail] = useState(false);
  const [listAccountCompany, setListAccountCompany] = useState([]);
  const { notifications, setNotifications } = useNotification();
  const [department, setDepartments] = useState([])

  const handleStartTour = useCallback(() => {
    if (!allowRoute || !pageName) return;
    const steps = getTourStepsByPage(pageName, t, { isAdmin });
    if (!steps.length) {
      toast.info(t("tour.not-available"));
      return;
    }
    setSteps(steps);
    setCurrentStep(0);
    setIsOpen(true);
  }, [allowRoute, pageName, t, isAdmin, setSteps, setCurrentStep, setIsOpen]);

  useEffect(() => {
    let isMounted = true;          // tránh setState khi đã unmount
    const ac = new AbortController();

    const fetchDataDepartment = async () => {
      try {
        const response = await getListDepartment({
          langId: localStorage.getItem("i18nextLngId"),
          signal: ac.signal,
        });
        if (!isMounted) return;
        setDepartments(response.data.data);
      } catch (error) {
        if (!isMounted) return;
        if (error.name === "AbortError") return;
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      }
    };

    fetchDataDepartment();

    return () => {
      isMounted = false;
      ac.abort();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSm(window.innerWidth < 540);
      setIsMd(window.innerWidth < 768);
      setIsLg(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenCompanyDetails = () => {
    setOpenOptions(false);
    navigate("/controlpanel/company-profile");
  };

  const handleOpenMyAccount = () => {
    setOpenOptions(false);
    navigate("/controlpanel/my-profile");
  };

  const handleOpenLoginOptions = () => {
    setOpenLoginOptions(true);
    // refreshProfile();
    setOpenOptions(false);
  };

  const handleCloseLoginOptions = () => {
    setOpenLoginOptions(false);
  };

  const handleOpenVerifyEmail = () => {
    setOpenLoginOptions(false);
    setOpenOptions(false);
    setOpenVerifyEmail(true);
  };

  const handleCloseVerifyEmail = () => {
    setOpenVerifyEmail(false);
  };

  // State cho Popover
  const [notificationPopoverAnchor, setNotificationPopoverAnchor] =
    useState(null);

  // State cho Dialog lớn
  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);

  const handleOpenNotificationPopover = (event) => {
    setNotificationPopoverAnchor(event.currentTarget);
  };

  const handleCloseNotificationPopover = () => {
    setNotificationPopoverAnchor(null);
  };

  const handleOpenFullDialog = () => {
    setNotificationPopoverAnchor(null); // đóng popover
    setOpenNotificationDialog(true); // mở dialog lớn
  };

  const handleCloseFullDialog = () => {
    setOpenNotificationDialog(false);
  };

  const [notificationAnchor, setNotificationAnchor] = useState(null);

  const handleOpenNotificationDialog = (event) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleCloseNotificationDialog = () => {
    setNotificationAnchor(null);
  };

  const anchorRefLanguage = useRef(null);
  const anchorRefOptions = useRef(null);

  const handleClose = (event) => {
    if (
      anchorRefLanguage.current &&
      anchorRefLanguage.current.contains(event.target)
    ) {
      return;
    }
    setOpenLanguage(false);
  };

  const handleCloseOptions = (event) => {
    if (
      anchorRefOptions.current &&
      anchorRefOptions.current.contains(event.target)
    ) {
      return;
    }
    setOpenOptions(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Escape") {
      setOpenOptions(false);
      setOpenLanguage(false);
    }
  };

  const handleToggleLanguage = () => {
    setOpenLanguage(!openLanguage);
  };

  const handleToggleOptions = () => {
    setOpenOptions(!openOptions);
  };

  const handleRefreshData1 = useCallback(() => {
    setRefreshData1((prev) => !prev);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("i18nextLng")?.length > 2) {
      i18n.changeLanguage("en");
    }
  }, []);

  const dispatch = useDispatch();
  const handleChangeLanguage = (language) => {
    switch (language) {
      case "en":
        i18n.changeLanguage("en");
        dispatch(changeLanguage(language));
        break;
      case "vi":
        i18n.changeLanguage("vi");
        dispatch(changeLanguage(language));
        break;
      default:
        break;
    }
    setOpenLanguage(false);

    // setCookie("i18nextLng", language, {
    //    expires: 31536000,
    //    path: "/",
    // });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          // email: email,
          langId: localStorage.getItem("i18nextLngId"),
        };
        const response = await getAccountList(payload);
        setListAccountCompany(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (openLoginOptions) {
      fetchData();
    }
  }, [openLoginOptions]);

  useEffect(() => {
    const fetchListNotification = async () => {
      try {
        const payload = {
          user_id: profile.userId,
          role: isAdmin ? "ADMIN" : "USER",
          company_id: profile.companyId,
        };
        const response = await getListNotification(payload);
        const rawData = response.data;
        const notificationsWithId = rawData.flat().map((item, index) => ({
          ...item,
          notificationId: index + 1,
        }));

        setNotifications(notificationsWithId);
      } catch (error) {
        console.log(error);
      }
    };
    fetchListNotification();
  }, [refreshData1]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const payload = {
          statusId: 1,
          page: 1,
          pageSize: 500,
          status: null,
          langId: localStorage.getItem("i18nextLngId"),
        };
        const response = await getUserList(payload);
        const usersList = response.data.data;
        setAllUser(usersList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    if (!client) return;

    const subscription = client.subscribe("/ws/message", (result) => {
      const data = JSON.parse(result.body);
      handleRefreshData1();
    });

    client.send("/wsmr/message/", null, null);

    return () => {
      subscription.unsubscribe();
    };
  }, [client]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  return (
    <><div className={`control-navbar mx-auto ${!isCollapse && isSm ? "ml-[6%]" : ""
      }`}>
      {isSm ? (
        <div
          className="flex gap-1 cursor-pointer items-center"
          onClick={() => {
            setIsCollapse((prev) => !prev);
          }}
        >
          <Dashboard16pxSvg
            className="text-[#1F2937] hover:text-[#0057FF]"
          />
        </div>
      ) : (
        <>
          <div
            className="flex gap-1 cursor-pointer items-center"
            onClick={() => {
              setIsCollapse((prev) => !prev);
            }}
          >
            <Dashboard16pxSvg
              className="text-[#1F2937] hover:text-[#0057FF]"
            />

            <p className="text-[18px] text-[#1F2937] leading-normal font-bold">
              {pageTitle}
            </p>
          </div>
        </>

      )}
      <div className="flex gap-1 md:gap-6 items-center">
        <>
          <div className="flex gap-2">
            <ControlpanelSuccess3thButton
              onClick={handleRefreshData}
            >
              <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
              {!isLg && <p>{t("button.refresh-data")}</p>}
            </ControlpanelSuccess3thButton>

            <ControlpanelPrimaryButton
              className="!pl-[6px] pointer-events-none opacity-50"
              onClick={handleStartTour}
            >
              <PlusIcon14pxSvg />
              {!isLg && <p>{t("button.start-tour")}</p>}
            </ControlpanelPrimaryButton>
          </div>
        </>

        <NotificationBell
          onClick={handleOpenNotificationPopover}
          notifications={notifications}
        />

        <Popover
          open={Boolean(notificationPopoverAnchor)}
          anchorEl={notificationPopoverAnchor}
          onClose={handleCloseNotificationPopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow:
                "0px 5px 15px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08)",
            },
          }}
        >
          <NotificationFirstDialog
            onClose={handleCloseNotificationPopover}
            onOpenFullDialog={handleOpenFullDialog} // truyền xuống
            notifications={notifications}
            handleRefreshData={handleRefreshData1}
            allUser={allUser}
          />
        </Popover>

        {openNotificationDialog && (
          <NotificationDialog
            onClose={handleCloseFullDialog}
            notifications={notifications}
            handleRefreshData={handleRefreshData1}
            allUser={allUser}
          />
        )}

        <StyledLink
          component="button"
          ref={anchorRefOptions}
          id="navbar-options-button"
          className="avatar-options"
          onClick={handleToggleOptions}
        >
          <Avatar
            variant="rounded"
            src={
              profile.profilePicture
                ? `data:image/png;base64,${profile.profilePicture}`
                : default_avatar
            }
            sx={{
              width: 40,
              height: 40,
              borderRadius: "4px",
              border: "1px solid #E5E7EB",
              bgcolor: "#fff",
              p: "2px",
              "& img": {
                borderRadius: "4px",
                objectFit: "cover",
              },
            }}
          />

          {!isMd && (
            openOptions ? (
              <ExpandMoreIcon sx={{ fontSize: 18 }} />
            ) : (
              <ExpandLessIcon sx={{ fontSize: 18 }} />
            )
          )}
        </StyledLink>
      </div>

      <Popper
        open={openLanguage}
        anchorEl={anchorRefLanguage.current}
        role={undefined}
        placement="bottom-end"
        transition
        disablePortal
        className="z-10 pt-2"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "left top" : "left bottom",
            }}
          >
            <Paper style={{ borderRadius: "8px", }}>
              <ClickAwayListener onClickAway={handleClose}>
                <NavbarLanguageMenuList
                  autoFocusItem={openLanguage}
                  id="navbar-language-menu"
                  aria-labelledby="navbar-language-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem>
                    <Link
                      onClick={() => {
                        handleChangeLanguage("en");
                      }}
                    >
                      {t("common.languageEn")}
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link
                      onClick={() => {
                        handleChangeLanguage("vi");
                      }}
                    >
                      {t("common.languageVi")}
                    </Link>
                  </MenuItem>
                </NavbarLanguageMenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <Popper
        open={openOptions}
        anchorEl={anchorRefOptions.current}
        role={undefined}
        placement="bottom-end"
        transition
        disablePortal
        className="z-10"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "left top" : "left bottom",
            }}
          >
            <Paper
              className="mt-4"
              sx={{
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <ClickAwayListener onClickAway={handleCloseOptions}>
                <div className="max-w-[500px] flex flex-col">
                  <div className="flex justify-between gap-12 items-center px-5 py-2 pt-5 bg-[#F3F4F6]">
                    <div className="flex flex-col gap-1 line-clamp-2">
                      <p className="text-sm font-bold">
                        {language === "vi"
                          ? profile.fullName
                          : profile.fullName}
                      </p>
                      <p className="text-sm">{profile.email}</p>
                      <p className="text-[14px] font-medium text-[#3B82F6]">{t(`roles3.${profile.role}`)}</p>

                      <p className="text-sm text-[#3B82F6] hidden">
                        {t("navbar.customer")}
                      </p>
                      <ErrorSecondaryButton
                        sx={{ display: "none" }}
                        onClick={handleOpenVerifyEmail}
                      >
                        {t("button.verify-your-email")}
                      </ErrorSecondaryButton>
                    </div>
                    <Avatar
                      variant="rounded"
                      src={
                        profile.profilePicture
                          ? `data:image/png;base64,${profile.profilePicture}`
                          : default_avatar
                      }
                      sx={{
                        width: 90,
                        height: 90,
                        borderRadius: "4px",
                        border: "1px solid #E5E7EB",
                        bgcolor: "#fff",
                        p: "5px",
                        "& img": {
                          borderRadius: "4px",
                          objectFit: "cover",
                        },
                      }}
                    />
                  </div>
                  <div className="h-[1px] bg-[#E7E7E7] w-fullmb-2"></div>
                  <MenuList>
                    <NavbarMenuItem onClick={handleOpenMyAccount}>
                      <div className="flex items-center gap-3">
                        <UserIcon16pxSvg sx={{ fontSize: "16px" }} />
                        <p className="text-sm">
                          {t("navbar.my-account.title")}
                        </p>
                      </div>
                    </NavbarMenuItem>

                    {isAdmin && profile.owner && (
                      <NavbarMenuItem onClick={handleOpenCompanyDetails}>
                        <div className="flex items-center gap-3">
                          <CompanyIcon16pxSvg sx={{ fontSize: "16px" }} />
                          <p className="text-sm">
                            {t("sign-up-organization.company-details")}
                          </p>
                        </div>
                      </NavbarMenuItem>
                    )}

                    <NavbarMenuItem onClick={handleOpenLoginOptions}>
                      <div className="flex items-center gap-3">
                        <ChangeRole20pxSvg sx={{ fontSize: "16px" }} />
                        <p className="text-sm">
                          {t("navbar.login-options.title")}
                        </p>
                      </div>
                    </NavbarMenuItem>
                    {/* <NavbarMenuItem onClick={handleOpenLoginOptions}>
                    <div className="flex items-center gap-3">
                      <SettingsIcon sx={{ fontSize: "16px" }} />
                      <p className="ml-1 text-sm">
                        {t("navbar.login-options.title")}
                      </p>
                    </div>
                  </NavbarMenuItem> */}
                    <div className="flex items-center justify-between w-full ml-[2px] px-5 py-1">
                      {/* LEFT */}
                      <div className="flex items-center gap-[14px]">
                        <LanguageIcon20pxSvg className="font-medium " sx={{ fontSize: 16 }} />
                        <p className="text-sm">{t("navbar.language")}</p>
                      </div>

                      {/* RIGHT - Language Switch */}
                      <div className="flex items-center bg-[#F5F8FF] rounded-md p-[3px]">
                        <button
                          onClick={() => changeLanguage("vi")}
                          className={`px-3 py-1 text-xs font-medium rounded-md transition
        ${i18n.language === "vi"
                              ? "bg-white text-[#0057FF] shadow-sm"
                              : "text-[#9CA3AF]"
                            }
      `}
                        >
                          VN
                        </button>

                        <button
                          onClick={() => changeLanguage("en")}
                          className={`px-3 py-1 text-xs font-medium rounded-full transition
        ${i18n.language === "en"
                              ? "bg-white text-[#0057FF] shadow-sm"
                              : "text-[#9CA3AF]"
                            }
      `}
                        >
                          EN
                        </button>
                      </div>
                    </div>

                    <div className="h-[1px] bg-[#E7E7E7] w-full my-3"></div>
                    <NavbarMenuItem onClick={handleLogout}>
                      <Link>
                        <div className="flex items-center gap-3">
                          <LogoutIcon sx={{ fontSize: "16px" }} />
                          <p className="ml-1 text-sm">{t("button.sign-out")}</p>
                        </div>
                      </Link>
                    </NavbarMenuItem>
                  </MenuList>
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {openLoginOptions && (
        <LoginOptionsDialog
          onClose={handleCloseLoginOptions}
          listAccountCompany={listAccountCompany}
        />
      )}
      {openVerifyEmail && (
        <VerifyYourEmailDialog onClose={handleCloseVerifyEmail} />
      )}
    </div></>

  );
};

export default ControlPanelNavbar;
